import { render } from "./WarrantyDetails.vue?vue&type=template&id=0e5ffd50"
import script from "./WarrantyDetails.vue?vue&type=script&lang=js"
export * from "./WarrantyDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__